import React from 'react';
import { Box } from '@mui/material';
import Button from '@mui/material/Button';
import Paper from '@mui/material/Paper';
import Typography from '@mui/material/Typography';
import { makeStyles } from 'tss-react/mui';

import { useChainList } from 'modules/common';
import { useTranslation } from 'modules/i18n';
import { useGetChainIdQuery, useSwitchNetworkMutation } from 'modules/store';

import translation from './unsupportedNetwork.translation';

export function UnsupportedNetwork(): JSX.Element {
  const { t, keys } = useTranslation(translation);
  const { classes } = useStyles();
  const { data: currentChainId } = useGetChainIdQuery();
  const chains = useChainList();

  const [switchNetwork] = useSwitchNetworkMutation();

  return (
    <Paper
      className={classes.container}
      data-tid="auth-unsupported-network-modal"
    >
      <Typography variant="h6" mt={6}>
        {t(keys.wrongNetwork)}
      </Typography>

      <Typography
        variant="body2"
        mt={6}
        color={theme => theme.palette.grey[500]}
      >
        {t(keys.description)}
      </Typography>

      {currentChainId &&
        chains.map(({ icon, name, chainId }) => (
          <Button
            data-tid={`auth-unsupported-network-modal-button-${chainId}`}
            className={classes.button}
            variant="outlined"
            size="extraLarge"
            type="button"
            onClick={() => switchNetwork({ chainId })}
            startIcon={
              icon.rounded && (
                <Box component="img" width={36} src={icon.rounded} alt={name} />
              )
            }
          >
            <Typography
              variant="body2"
              component="span"
              width="100%"
              textAlign="left"
              color={theme => theme.palette.grey[900]}
            >
              {name}
            </Typography>

            <Typography
              className={classes.connect}
              variant="button2"
              component="div"
            >
              {t(keys.connect)}
            </Typography>
          </Button>
        ))}
    </Paper>
  );
}

const useStyles = makeStyles<void, 'connect'>()((theme, _, classes) => ({
  container: {
    '&&': {
      display: 'flex',
      flexDirection: 'column',
      alignItems: 'center',
      maxWidth: 560,
      width: '100%',
      margin: 'auto',
      padding: theme.spacing(15),

      [theme.breakpoints.down('md')]: {
        marginTop: theme.spacing(6.5),
        justifyContent: 'center',
        padding: theme.spacing(0, 4),
        minHeight: 486,
      },
    },
  },
  button: {
    '&&': {
      width: '100%',
      marginTop: theme.spacing(6),

      [`&:hover > .${classes.connect}`]: {
        opacity: 1,
      },
    },
  },

  connect: {
    opacity: 0,
  },
}));
